<template>
    <rkm-modal
        ref="Modal"
        large
        title="Observação"
        :buttons="['cancel']"
    >
        <span>
            {{ model.pedidoExame.exame.observacao }}
        </span>
    </rkm-modal>
</template>

<script>

// Components

export default {
    data: () => ({
        form: {
            exame: null
        },
        model: {
            pedidoExame : {
                index: null,
                id: null,
                exame: {
                    id: null,
                    index: null,
                    observacao: '',
                    disabled: false
                }
            }
        }
    }),
    methods: {
        open(pedido, exame) {

            this.form.exame = exame.exame

            this.model.pedidoExame.id = pedido.item.id
            this.model.pedidoExame.index = pedido.index

            this.model.pedidoExame.exame.index = exame.exameIndex
            this.model.pedidoExame.exame.disabled = exame.exame.disabled
            this.model.pedidoExame.exame.observacao = exame.exame.exame.observacao || ''
            this.model.pedidoExame.exame.id = exame.exame.id

            this.$refs.Modal.show()
        },
    }
}
</script>